import { withCompInfo } from '../../core/withCompInfo'
import {
	SlideShowGalleryCarmiData,
	SlideShowGalleryDefinition,
	SlideShowGalleryProps,
	SlideShowGalleryCSS,
	SlideShowGallerySdkData,
} from './types'
import { legacyTransitionTypesMap } from '../../core/constants'

export const props = withCompInfo<SlideShowGalleryProps, SlideShowGalleryDefinition, SlideShowGalleryCarmiData>(
	['skin', 'compProps'],
	({ skin, compProps }, carmiData) => {
		const transition = legacyTransitionTypesMap[compProps.transition]
		const hasTransition = transition !== 'NoTransition'
		const transitionDuration = compProps.transDuration * 1000
		const autoPlayInterval = compProps.autoplayInterval * 1000 + (hasTransition ? transitionDuration : 0)

		return {
			skin,
			items: carmiData.itemsProps,
			currentIndex: 0,
			transition,
			transitionDuration,
			transitionReverse: compProps.reverse,
			shouldPreserveAspectRatio: compProps.imageMode === 'flexibleHeight',
			autoPlay: compProps.autoplay,
			autoPlayInterval,
			showNavigation: compProps.showNavigation,
			showAutoplay: compProps.showAutoplay,
			showCounter: compProps.showCounter,
			reducedMotion: false,
			imageOnClickAction: compProps.galleryImageOnClickAction,
			alignTextRight: compProps.alignText === 'right',
		}
	}
)

export const css = withCompInfo<SlideShowGalleryCSS, SlideShowGalleryDefinition>(
	['compLayout', 'compProps'],
	({ compLayout, compProps }) => {
		const { transDuration, imageMode } = compProps

		return {
			height: imageMode === 'flexibleHeight' ? 'auto' : `${compLayout.height}px`,
			'--transition-duration': `${transDuration * 1000}ms`,
			'--alpha-txt': '1',
		}
	}
)

const imageModeToDisplayMode = {
	clipImage: 'fill',
	flexibleHeight: 'fill',
	flexibleWidthFixed: 'fit',
} as const

export const sdkData = withCompInfo<SlideShowGallerySdkData, SlideShowGalleryDefinition>(
	['compProps', 'compData'],
	({ compProps, compData }) => {
		return {
			imageDisplayMode: imageModeToDisplayMode[compProps.imageMode],
			dataId: compData.id,
		}
	}
)
